// Serialize query params for axios GETs: scalars appended once, arrays appended
// per entry (repeated keys), null/undefined skipped. Shared so callers that send
// the same filter shape can't drift in how they encode it.
export function serializeQueryParams(
  queryParams: Record<string, unknown>
): string {
  const searchParams = new URLSearchParams();
  Object.entries(queryParams || {}).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    if (Array.isArray(value)) {
      value.forEach((entry) => {
        if (entry !== undefined && entry !== null) {
          searchParams.append(key, String(entry));
        }
      });
      return;
    }
    searchParams.append(key, String(value));
  });
  return searchParams.toString();
}
